import { createContext, useContext, useState, useEffect, type ReactNode } from "react";

export type Theme = "light" | "jaggery";

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType>({
  theme: "light",
  toggleTheme: () => {},
});

function applyTheme(t: Theme) {
  if (t === "jaggery") {
    document.documentElement.setAttribute("data-theme", "jaggery");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>("light");

  useEffect(() => {
    const saved = (localStorage.getItem("app-theme") as Theme) || "light";
    setTheme(saved);
    applyTheme(saved);
  }, []);

  const toggleTheme = () => {
    const next: Theme = theme === "light" ? "jaggery" : "light";
    setTheme(next);
    applyTheme(next);
    localStorage.setItem("app-theme", next);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
